<div class="login-body">
    <div class="login-panel surface-card p-6 shadow-2 border-round w-full lg:w-3">
        <form #passConfigForm="ngForm"
              *ngIf="user"
              (ngSubmit)="confirmarGuardarContrasenia()"
              [ngClass]="{'disabledForm': false}"
              autocomplete="false">
            <div class="text-center mb-5">
                <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" height="100h" class="mb-3 responsive">
                <div class="text-600 text-3xl font-medium mb-3">¡Ya casi terminamos!</div>
                <span class="text-600 font-medium line-height-3 uppercase">Llena el formulario con tu <strong>nueva contraseña</strong></span><br>
            </div>
            <p-messages [(value)]="msgs"></p-messages>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12">
                    <label for="contrasenia">Contraseña</label>
                    <p-password #contrasenia="ngModel" id="contrasenia" name="contrasenia"
                                [(ngModel)]="password" 
                                [toggleMask]="true"
                                mode="advanced" promptLabel="Débil"
                                weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
                                [feedback]="true"
                                strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
                                [feedback]="false"
                                [required]="true">
                        <ng-template pTemplate="header">
                            <h6>Escoge una contraseña</h6>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="p-mt-2">Sugerencias</p>
                            <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                                <li>Al menos una minúscula</li>
                                <li>Al menos una mayúscula</li>
                                <li>Al menos una numérica</li>
                                <li>Un mínimo de 8 caracteres</li>
                            </ul>
                        </ng-template>
                    </p-password>
                    <p-message
                        severity="error"
                        [text]="appConfig['validationMsgs']['passwordInvalid']"
                        *ngIf="passwordInvalid">
                    </p-message>
                </div>
                <div class="field col-12">
                    <label for="contraseniaConfirm">Confirmar contraseña</label>
                    <p-password #contraseniaConfirm="ngModel" id="contraseniaConfirm" name="contraseniaConfirm" 
                                (onBlur)="comparePassword($event);"
                                [(ngModel)]="passwordConfirm"
                                ngDefaultControl="true" [toggleMask]="true"
                                mode="advanced" promptLabel="Débil"
                                weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
                                [feedback]="false"
                                strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
                                [feedback]="false"
                                [required]="true">
                        <ng-template pTemplate="header">
                            <h6>Escoge una contraseña</h6>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="p-mt-2">Sugerencias</p>
                            <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                                <li>Al menos una minúscula</li>
                                <li>Al menos una mayúscula</li>
                                <li>Al menos una numérica</li>
                                <li>Un mínimo de 8 caracteres</li>
                            </ul>
                        </ng-template>
                    </p-password>
                    <p-message
                        severity="error"
                        [text]="appConfig['validationMsgs']['passwordInvalid']"
                        *ngIf="passwordInvalid">
                    </p-message>
                </div>
                <div class="field col-12">
                    <button pButton pRipple 
                            type="submit"
                            label="{{'RESTABLECER MI CONTRASEÑA'}}"
                            icon="pi pi-key" class="w-full p-button-danger p-button-rounded" 
                            [disabled]="(!passConfigForm.valid)">
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="inline-flex">
            <i [class]="(resultData['type'] && resultData['type'].includes('success')) ? 'pi pi-check-square text-6xl' : 'pi pi-exclamation-triangle text-6xl'"></i>
            <span class="ml-1 align-self-center">{{resultData['body']}}</span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>